import { render, staticRenderFns } from "./member.vue?vue&type=template&id=640d6750&scoped=true"
import script from "./member.vue?vue&type=script&lang=js"
export * from "./member.vue?vue&type=script&lang=js"
import style0 from "./member.vue?vue&type=style&index=0&id=640d6750&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640d6750",
  null
  
)

export default component.exports